const state = {
  searchString: null,
}

const getters = {
  getSearchString: (state) => state.searchString,
}

const actions = {
  async setSearchString({commit}, searchString) {
    commit('searchStringSet', searchString)
  },
}

const mutations = {
  searchStringSet(state, searchString) {
    state.searchString = searchString
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
